<template>
  <DxLookup
    :ref="dropDownBoxRefName"
    :drop-down-options="dropDownOptions"
    :data-source="dataSource"
    :value.sync="currentValue"
    :display-expr="salesUmField"
    :value-expr="salesUmField"
    :on-value-changed="onSelectionChanged"
    item-template="list-item"
    @focus-in="focusIn"
  >
    <template #list-item="{ data }">
      <div class="gc-dropdown-list-item">{{ data[salesUmField] }}</div>
    </template>
  </DxLookup>
</template>
<script>
import { DxLookup } from "devextreme-vue/lookup";

const dropDownBoxRefName = "dropDownBoxRef";

export default {
  components: {
    DxLookup,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    onValueChanged: {
      type: Function,
      default: () => function() {},
    },
    dataSource: {
      type: [Object, Array],
      default: () => {},
    },
    cellInfo: {
      type: Object,
      default: () => {},
    },
    focusIn: {
      type: Function,
      default: () => function() {},
    },
    salesUmField: {
      type: String,
      default: "SalesUM",
    },
  },
  data() {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 100 },
      dropDownBoxRefName,
    };
  },
  methods: {
    onSelectionChanged(selectionChangedArgs) {
      // eslint-disable-next-line no-debugger
      // debugger;
      this.currentValue = selectionChangedArgs.value;
      this.onValueChanged(selectionChangedArgs, this.cellInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.gc-dropdown-list-item {
  font-size: 14px;
}
</style>
